<template>
  <div class="myprize-page"  v-show="showPage">
    <div class="content-wrap" ref="contentBScrollWrap">
      <ul>
        <li v-for="(item, index) in prizelist" :key="index">
          <div class="prize-box">
            <div class="prize-content">
              <div class="prize-text">
                <p class="prize-name" v-html="item.prize_name"></p>
                <p class="prize-time">中奖时间:{{item.created_at}}</p>
              </div>
              <img v-if="item.status === 3" class="btn" src="../../assets/myprize/btn_got.png" alt="">
              <img  v-else-if="item.status === 2" @click="getPrize(item.user_prize_id)" class="btn" src="../../assets/myprize/btn_get.png" alt="">
              <img  v-else class="btn" src="../../assets/myprize/btn_used.png" alt="">
            </div>
          </div>
        </li>
        <li v-show="!prizelist || prizelist.length < 1">
          <div class="no-prize-box">
            <p class="noprize">暂无奖品</p>
          </div>
        </li>
      </ul>
      <div class="back">
        <div @click="back" class="back-btn"></div>
      </div>
    </div>
  </div>
</template>

<script>
import { Toast } from 'vant'
export default {
  name: 'myprize-page',
  data () {
    return {
      showPage: false,
      act_id: window.$inrice.actID || 1,
      indexData: Object.create(null), //  data from backend
      controlText: 1,
      dialogConfig: { isShow: 0 },
      prizelist: [
        // {
        //   contact_address: '天河',
        //   contact_name: '啵啵',
        //   contact_phone: '15818878122',
        //   created_at: '2020-09-08 11:24:52',
        //   end_date: '2020-09-08 23:59:59',
        //   expired_at: '2020-09-09 11:24:52',
        //   image: 'https://qhd-oss.inrice.cn/1599132566190.png',
        //   prize_code: '',
        //   prize_desc: '奖品说明奖品说明奖品说明奖品说明奖品说明奖品说明奖品说明奖品说明奖品说明奖品说明奖品说明奖品说明',
        //   prize_name: '抖音网红泡泡机',
        //   prize_price: '0.00',
        //   status: 0,
        //   type: 6,
        //   user_prize_id: 1,
        //   box_control: 1
        // },
        // {
        //   contact_address: '天河',
        //   contact_name: '啵啵',
        //   contact_phone: '15818878122',
        //   created_at: '2020-09-08 11:24:52',
        //   end_date: '2020-09-08 23:59:59',
        //   expire_date: '2020-09-09 11:24:52',
        //   image: 'https://qhd-oss.inrice.cn/1599132566190.png',
        //   prize_code: '',
        //   prize_desc: '奖品说明奖品说明奖品说明奖品说明奖品说明奖品说明奖品说明奖品说明奖品说明奖品说明奖品说明奖品说明',
        //   prize_name: '抖音网红泡泡机',
        //   prize_price: '0.00',
        //   status: 1,
        //   type: 6,
        //   user_prize_id: 1,
        //   box_control: 1
        // }
      ],
      verifyDialog: {
        isShow: false
      }
    }
  },
  computed: {},
  components: {},
  methods: {
    getPrize(id) {
      if (!this.$parent.timeCheck()) return
      this.$router.push({ name: 'client-reg', query: { user_prize_id: id } })
    },
    copy(code) {
      // const clipboard = new Clipboard('.code-text')
      // clipboard.on('success', e => {
      //   Toast('复制成功')
      //   // 释放内存
      //   clipboard.destroy()
      // })
      // clipboard.on('error', e => {
      //   // 不支持复制
      //   Toast('手机不支持自动复制，请手动长按选择复制')
      //   // 释放内存
      //   clipboard.destroy()
      // })
      this.$stat({ event: 'btn_copy' })
      const input = document.createElement('input')
      input.setAttribute('readonly', 'readonly')
      input.setAttribute('value', code)
      document.body.appendChild(input)
      document.execCommand('selectAll')
      input.focus() // 少了这行代码复制不了
      input.setSelectionRange(0, input.value.length)
      if (document.execCommand('copy')) {
        Toast('复制成功')
      } else {
        Toast('手机不支持自动复制，请手动长按选择复制')
      }
      document.body.removeChild(input)
    },
    async getMyPrize (isShowLoading = true) {
      isShowLoading && this.$loading.show()
      try {
        const { data } = await this.$fetch.get('/psbs-gd-lottery/user-prize', {
          actid: window.$inrice.actID
        })
        this.prizelist = data.data
        this.prizelist = this.prizelist.map((val) => {
          return { ...val, box_control: 1 }
        })
      } catch (e) {
        Toast(e.response.data.message)
      }
      isShowLoading && this.$loading.hide()
    },
    back() {
      this.$stat({ event: 'prize_btn_back' }) // 上报事件
      this.$router.back(-1)
    }
  },
  async created () {
    this.$stat({ event: 'page_prize' })
    // 加载基础活动信息和个人信息
    this.$loading.show()
    await this.getMyPrize()
    setTimeout(() => {
      this.showPage = true
      this.$loading.hide()
    }, 100)
  }
}
</script>

<style lang="scss" scoped>
.myprize-page{
  position: relative;
  width: 750px;
  min-height: 1380px;
  background-image: url(../../assets/home/bg.png);
  background-size: 100%;
  text-align: center;
  padding-top: 200px;
  .title{
    font-size: 32px;
    color: #9C4200;
    margin-bottom: 30px;
    .red{
      color: #FF6C13;
    }
  }
  .no-prize-box{
    padding-top: 200px;
    width:100%;
    .noprize{
      width: 100%;
      font-size: 60px;
      font-weight: bold;
      color: #ffffff;
      text-align: center;
      margin-bottom: 200px;
    }
  }
  .prize-box{
    margin-top: 50px;
    width: 671px;
    height: 203px;
    display: block;
    margin: 0 auto;
    margin-bottom: 20px;
    background-image: url(../../assets/myprize/prize_box.png);
    background-size: 100%;
    overflow: hidden;
    position: relative;
    img{
      display: block;
    }
    .prize-content{
      height: 203px;
      display: flex;
      padding: 30px 30px;
      justify-content: flex-start;
      align-items: center;
      font-size: 24px;
      text-align: left;
      width: 100%;
      // background-color: #ffffff;
      word-wrap:break-word;
      word-break:normal;
      color: #893C16;
      .prize-text{
        width: 460px;
        font-size: 24px;
        padding-left: 100px;
        .prize-name{
          font-size: 40px;
          color: #FD3348;
        }
        .prize-time{
          color: #333333;
        }
      }
      .btn{
        width: 160px;
      }

    }
    .left{
      text-align: left;
      color: #241C1C;
    }
    .center{
      text-align: center;
    }
    .flex{
      // display: flex;
      // justify-content: flex-start;
      // align-items: center;
      display: block;
      text-align: left;
    }
  }
  .back{
    margin: 0 auto;
    margin-top: 20px;
    .back-btn{
      margin: 0 auto;
      width: 310px;
      height: 102px;
      background: url(../../assets/popup/btn_back.png) no-repeat;
      background-size: 100% 100%;
      font-size: 34px;
      font-weight: bold;
      color: #5C3609;
      line-height: 100px;
      text-align: center;
    }
  }
}
</style>
